import {
  Box,
  BoxProps,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";
import { CustomDialog } from "@components/CustomDialog";

export interface CustomCheckListProps extends BoxProps {
  title: string;
  items: Array<string>;
  tooltip?: string;
}

export const CustomCheckList = (props: CustomCheckListProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [statusOpen, setStatusOpen] = useState<boolean>(false);

  return (
    <>
      <Box
        sx={{ backgroundColor: theme?.palette?.phoneInput?.main, borderRadius: "8px", ...props.sx }}
        px={2}
        py={1}
        display={"flex"}
        flexDirection={"column"}
      >
        <Typography
          textAlign={"left"}
          variant={isMobileOrTablet ? "body2" : "body1"}
          fontWeight={theme?.palette?.fontWeights?.semibold}
          color={theme?.palette?.primary?.dark}
        >
          {props.title}
          {props.tooltip && (
            <IconButton sx={{ margin: "-5px 2px 0px 2px", padding: 0 }} onClick={() => setStatusOpen(true)}>
              <InfoOutlinedIcon color={"error"} sx={{ width: 15, height: 15 }} />
            </IconButton>
          )}
        </Typography>
        <List>
          {props.items.map((item, index) => {
            return (
              <ListItem key={index} sx={{ p: 0 }}>
                <ListItemIcon sx={{ minWidth: "15px" }}>
                  <Box width={8} height={8} sx={{ backgroundColor: theme?.palette?.primary?.main }}></Box>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography color={theme?.palette?.primary?.dark} variant={isMobileOrTablet ? "body2" : "body1"}>
                      {item}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </Box>

      <CustomDialog
        colorClose="#F2704F"
        open={statusOpen}
        onClose={() => setStatusOpen(false)}
        itemTitle={
          <Typography variant="body1" color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={600}>
            {props.title}
          </Typography>
        }
        itemContent={
          <Typography variant="body2" textAlign={"center"}>
            {props.tooltip}
          </Typography>
        }
      />
    </>
  );
};
